import React from "react";
import { useStyles } from "./style";
import { Grid } from "@material-ui/core";
import { Link } from "gatsby";

export default function CelebStory({ post }) {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
      <div className={classes.container}>
        <Link to={post?.uri} title={post?.title}>
          <div className={classes.imgBox}>
            <img
              src={post?.featuredImage?.node?.mediaItemUrl}
              alt={post?.title}
              className={classes.img}
            />
          </div>
        </Link>
        <div className={classes.bottomItem}>
          <p className={classes.title}>{post?.blogPost?.celebrity}</p>
          <div className={classes.line} />
        </div>
      </div>
    </Grid>
  );
}
